import {
	CurrencyCodeEnum,
	DiscountStateEnum,
	DisplayType,
	ItineraryView,
	LegView,
	PassengerLegStatusEnum,
	PaymentFormEnum,
	PaymentStateEnum,
	TripTypeEnum,
} from '../lib/heyapi.gen';

export const itineraryLBODTFlex: ItineraryView = {
	startDateTime: '2024-01-24T14:13:27.106Z',
	endDateTime: '2024-01-24T15:38:31.106Z',
	duration: 2102,
	walkTime: 0,
	walkDistance: 0,
	airDistance: 26605,
	paymentOptions: [PaymentFormEnum.DIGITAL],
	dticketEligible: false,
	legs: [
		{
			legId: 'd83adc3f-eadd-46c3-bbbc-e24e6a42bd12',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-24T14:13:27.106Z',
			startDateTimeWindowStart: '2024-01-24T14:13:27.106817073Z',
			startDateTimeWindowEnd: '2024-01-24T14:28:27.106817073Z',
			startDateTimeFix: false,
			endDateTime: '2024-01-24T15:38:31.106Z',
			endDateTimeWindowStart: '2024-01-24T14:13:27.106817073Z',
			endDateTimeWindowEnd: '2024-01-24T15:38:31.106817073Z',
			endDateTimeFix: false,
			cancellationFreeUntil: '2024-01-24T13:13:27.106Z',
			costOfCancellation: 640,
			duration: 2102.1,
			distance: 33464.5,
			mode: TripTypeEnum.LBODTFLEX,
			modeOrigin: 'CAR',
			route: '',
			agencyName: 'Vetter Verkehrsbetriebe',
			from: {
				name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
				lng: '12.044637',
				lat: '51.855333',
				arrival: '2024-01-24T14:13:27.106Z',
				departure: '2024-01-24T14:13:27.106Z',
				locationType: DisplayType.ADDRESS,
			},
			to: {
				name: 'Wolfen, Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
				lng: '12.275519',
				lat: '51.66343',
				arrival: '2024-01-24T15:38:31.106Z',
				departure: '2024-01-24T15:38:31.106Z',
				locationType: DisplayType.ADDRESS,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 640,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
					pricePerPassenger: 640,
					deploymentPrice: 0,
				},
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 740,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
					pricePerPassenger: 740,
					deploymentPrice: 0,
				},
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 1650,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
					pricePerPassenger: 1650,
					deploymentPrice: 0,
				},
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 2020,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 2020,
					deploymentPrice: 0,
				},
			],
			cancellationRules: [
				{
					secondsBeforeRideStart: 7200,
					cost: 10,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 1800,
					cost: 320,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 0,
					cost: 920,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 7200,
					cost: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					secondsBeforeRideStart: 1800,
					cost: 50,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					secondsBeforeRideStart: 0,
					cost: 100,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
			],
		},
	],
	signature: 'signature',
};

export const legLBODTFlex: LegView = {
	legId: 'd83adc3f-eadd-46c3-bbbc-e24e6a42bd12',
	legStatus: PassengerLegStatusEnum.BOOKED,
	startDateTime: '2024-01-24T14:13:27.106Z',
	startDateTimeWindowStart: '2024-01-24T14:13:27.106817073Z',
	startDateTimeWindowEnd: '2024-01-24T14:28:27.106817073Z',
	startDateTimeFix: false,
	endDateTime: '2024-01-24T15:38:31.106Z',
	endDateTimeWindowStart: '2024-01-24T14:13:27.106817073Z',
	endDateTimeWindowEnd: '2024-01-24T15:38:31.106817073Z',
	endDateTimeFix: false,
	cancellationFreeUntil: '2024-01-24T13:13:27.106Z',
	costOfCancellation: 640,
	duration: 2102.1,
	distance: 33464.5,
	mode: TripTypeEnum.LBODTFLEX,
	modeOrigin: 'CAR',
	route: '',
	agencyName: 'Vetter Verkehrsbetriebe',
	from: {
		name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
		lng: '12.044637',
		lat: '51.855333',
		arrival: '2024-01-24T14:13:27.106Z',
		departure: '2024-01-24T14:13:27.106Z',
		locationType: DisplayType.ADDRESS,
	},
	to: {
		name: 'Wolfen, Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
		lng: '12.275519',
		lat: '51.66343',
		arrival: '2024-01-24T15:38:31.106Z',
		departure: '2024-01-24T15:38:31.106Z',
		locationType: DisplayType.ADDRESS,
	},
	payment: {
		currencyCode: CurrencyCodeEnum.EUR,
		paymentAmount: 740,
		paymentForm: PaymentFormEnum.DIGITAL,
		paymentInformationAvailable: true,
		paymentState: PaymentStateEnum.TO_PAY,
		overwrittenPaymentAmount: 600,
	},
	paymentOptions: [PaymentFormEnum.DIGITAL],
	intermediateStops: [],
	pricings: [
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 640,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
			pricePerPassenger: 640,
			deploymentPrice: 0,
		},
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 740,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
			pricePerPassenger: 740,
			deploymentPrice: 0,
		},
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 1650,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
			pricePerPassenger: 1650,
			deploymentPrice: 0,
		},
		{
			paymentHandlerCompanyName: 'MoPla Solutions GmbH',
			paymentHandlerCompanyType: 'MOPLA',
			paymentInformationAvailable: true,
			amount: 2020,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NO_DISCOUNT,
			pricePerPassenger: 2020,
			deploymentPrice: 0,
		},
	],
};

export const legLBT: LegView = {
	legId: '39b8d4d1-9677-4002-b467-04b492001367',
	legStatus: PassengerLegStatusEnum.BOOKED,
	startDateTime: '2024-02-19T10:00:00Z',
	startDateTimeFix: true,
	endDateTime: '2024-02-19T10:26:00Z',
	endDateTimeFix: true,
	duration: 1560,
	distance: 14681.88,
	mode: TripTypeEnum.LBT,
	modeOrigin: 'BUS',
	route: '470',
	headsign: 'Gröbzig, Mühlbreite',
	routeId: '1:VETTAB470',
	agencyId: '1:00906',
	agencyName: 'Vetter Verkehrsbetriebe',
	tripShortName: '4700014',
	tripId: '1:78960',
	from: {
		name: 'Aken, Markt',
		stopId: '1:000016812',
		lng: '12.044659',
		lat: '51.85455',
		arrival: '2024-02-19T10:00:00Z',
		departure: '2024-02-19T10:00:00Z',
		locationType: DisplayType.STOP,
	},
	to: {
		name: 'Köthen, Bahnhof (Bus)',
		stopId: '1:000004966',
		lng: '11.98812',
		lat: '51.752385',
		arrival: '2024-02-19T10:26:00Z',
		departure: '2024-02-19T10:33:00Z',
		locationType: DisplayType.STOP,
	},
	legGeometry: {
		points:
			'}yn{HanohAwE|Y??ff@`S??jh@vx@??~_A|h@??pc@|F??p`@hL??zg@joA??rs@yx@??dj@uE??`Tug@??`Gkp@??tTbh@??rB|iA??~bCdlA??liBhaA',
		length: 30,
	},
	paymentOptions: [PaymentFormEnum.DIGITAL],
	intermediateStops: [
		{
			arrival: '2024-02-19T10:02:00Z',
			departure: '2024-02-19T10:02:00Z',
			name: 'Aken, Sekundarschule',
		},
		{
			arrival: '2024-02-19T10:03:00Z',
			departure: '2024-02-19T10:03:00Z',
			name: 'Aken, Heidestr.',
		},
		{
			arrival: '2024-02-19T10:05:00Z',
			departure: '2024-02-19T10:05:00Z',
			name: 'Aken, Mennewitzer Weg',
		},
		{
			arrival: '2024-02-19T10:06:00Z',
			departure: '2024-02-19T10:06:00Z',
			name: 'Aken, Heidehof',
		},
		{
			arrival: '2024-02-19T10:07:00Z',
			departure: '2024-02-19T10:07:00Z',
			name: 'Trebbichau (Micheln), Wasserwerk',
		},
		{
			arrival: '2024-02-19T10:07:00Z',
			departure: '2024-02-19T10:07:00Z',
			name: 'Trebbichau (Micheln), Heidekrug',
		},
		{
			arrival: '2024-02-19T10:09:00Z',
			departure: '2024-02-19T10:09:00Z',
			name: 'Trebbichau (Micheln), Ort',
		},
		{
			arrival: '2024-02-19T10:12:00Z',
			departure: '2024-02-19T10:12:00Z',
			name: 'Osternienburg, Ernst-Thälmann-Str.',
		},
		{
			arrival: '2024-02-19T10:13:00Z',
			departure: '2024-02-19T10:13:00Z',
			name: 'Osternienburg, Apotheke',
		},
		{
			arrival: '2024-02-19T10:15:00Z',
			departure: '2024-02-19T10:15:00Z',
			name: 'Osternienburg, Neubau',
		},
		{
			arrival: '2024-02-19T10:16:00Z',
			departure: '2024-02-19T10:16:00Z',
			name: 'Osternienburg, Denkmal',
		},
		{
			arrival: '2024-02-19T10:18:00Z',
			departure: '2024-02-19T10:18:00Z',
			name: 'Osternienburg, Rudolf-Breitscheid-Str.',
		},
		{
			arrival: '2024-02-19T10:19:00Z',
			departure: '2024-02-19T10:19:00Z',
			name: 'Pißdorf (Osternienburg), Ortseingang',
		},
		{
			arrival: '2024-02-19T10:22:00Z',
			departure: '2024-02-19T10:22:00Z',
			name: 'Porst (Köthen), Dessauer Str.',
		},
	],
	pricings: [
		{
			paymentHandlerCompanyName: 'Vetter',
			paymentHandlerCompanyType: 'DISTRIBUTOR',
			paymentInformationAvailable: false,
			amount: 0,
			currency: CurrencyCodeEnum.EUR,
			discount: DiscountStateEnum.NO_DISCOUNT,
			pricePerPassenger: 0,
			deploymentPrice: 0,
		},
	],
	costOfCancellation: 123,
};

export const legWalk: LegView = {
	legId: '34d8c33d-9a39-4414-9ab8-42b4d8258e86',
	legStatus: PassengerLegStatusEnum.BOOKED,
	startDateTime: '2024-02-20T13:58:32Z',
	startDateTimeFix: true,
	endDateTime: '2024-02-20T14:00:00Z',
	endDateTimeFix: true,
	duration: 88,
	distance: 108.69,
	mode: TripTypeEnum.WALK,
	modeOrigin: TripTypeEnum.WALK,
	from: {
		name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
		lng: '12.04464',
		lat: '51.85535',
		departure: '2024-02-20T13:58:32Z',
		locationType: DisplayType.STOP,
	},
	to: {
		name: 'Aken, Markt',
		stopId: '1:000016812',
		lng: '12.044659',
		lat: '51.85455',
		arrival: '2024-02-20T14:00:00Z',
		departure: '2024-02-20T14:00:00Z',
		locationType: DisplayType.STOP,
	},
	legGeometry: {
		points: 'y~n{H}mohAB}@tBd@b@JAF',
		length: 5,
	},
	paymentOptions: [PaymentFormEnum.DIGITAL],
	intermediateStops: [],
	pricings: [],
	costOfCancellation: 123,
};

export const itineraryLBT: ItineraryView = {
	startDateTime: '2024-01-16T15:58:32Z',
	endDateTime: '2024-01-16T18:02:19Z',
	duration: 7427,
	walkTime: 287,
	walkDistance: 343.47,
	paymentOptions: [PaymentFormEnum.DIGITAL],
	airDistance: 0,
	dticketEligible: false,
	legs: [
		{
			legId: '06c44749-017e-416c-adca-e13046b1d0b8',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T15:58:32Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T16:00:00Z',
			endDateTimeFix: true,
			duration: 88,
			distance: 108.69,
			mode: TripTypeEnum.WALK,
			modeOrigin: TripTypeEnum.WALK,
			from: {
				name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
				lng: '12.04464',
				lat: '51.85535',
				departure: '2024-01-16T15:58:32Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Aken, Markt',
				stopId: '1:000016812',
				lng: '12.044659',
				lat: '51.85455',
				arrival: '2024-01-16T16:00:00Z',
				departure: '2024-01-16T16:00:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points: 'y~n{H}mohAB}@tBd@b@JAF',
				length: 5,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [],
			costOfCancellation: 123,
		},
		{
			legId: '0bc418d5-1afb-4c59-854d-27d504b6465e',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T16:00:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T16:26:00Z',
			endDateTimeFix: true,
			duration: 1560,
			distance: 14681.88,
			mode: TripTypeEnum.LBT,
			modeOrigin: 'BUS',
			route: '470',
			headsign: 'Gröbzig, Mühlbreite',
			routeId: '1:VETTAB470',
			agencyId: '1:00906',
			agencyName: 'Vetter Verkehrsbetriebe',
			tripShortName: '4700026',
			tripId: '1:79003',
			from: {
				name: 'Aken, Markt',
				stopId: '1:000016812',
				lng: '12.044659',
				lat: '51.85455',
				arrival: '2024-01-16T16:00:00Z',
				departure: '2024-01-16T16:00:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Köthen, Bahnhof (Bus)',
				stopId: '1:000004966',
				lng: '11.98812',
				lat: '51.752385',
				arrival: '2024-01-16T16:26:00Z',
				departure: '2024-01-16T16:33:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points:
					'}yn{HanohAwE|Y??ff@`S??jh@vx@??~_A|h@??pc@|F??p`@hL??zg@joA??rs@yx@??dj@uE??`Tug@??`Gkp@??tTbh@??rB|iA??~bCdlA??liBhaA',
				length: 30,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [
				{
					arrival: '2024-01-16T16:02:00Z',
					departure: '2024-01-16T16:02:00Z',
					name: 'Aken, Sekundarschule',
				},
				{
					arrival: '2024-01-16T16:03:00Z',
					departure: '2024-01-16T16:03:00Z',
					name: 'Aken, Heidestr.',
				},
				{
					arrival: '2024-01-16T16:05:00Z',
					departure: '2024-01-16T16:05:00Z',
					name: 'Aken, Mennewitzer Weg',
				},
				{
					arrival: '2024-01-16T16:06:00Z',
					departure: '2024-01-16T16:06:00Z',
					name: 'Aken, Heidehof',
				},
				{
					arrival: '2024-01-16T16:07:00Z',
					departure: '2024-01-16T16:07:00Z',
					name: 'Trebbichau (Micheln), Wasserwerk',
				},
				{
					arrival: '2024-01-16T16:07:00Z',
					departure: '2024-01-16T16:07:00Z',
					name: 'Trebbichau (Micheln), Heidekrug',
				},
				{
					arrival: '2024-01-16T16:09:00Z',
					departure: '2024-01-16T16:09:00Z',
					name: 'Trebbichau (Micheln), Ort',
				},
				{
					arrival: '2024-01-16T16:12:00Z',
					departure: '2024-01-16T16:12:00Z',
					name: 'Osternienburg, Ernst-Thälmann-Str.',
				},
				{
					arrival: '2024-01-16T16:13:00Z',
					departure: '2024-01-16T16:13:00Z',
					name: 'Osternienburg, Apotheke',
				},
				{
					arrival: '2024-01-16T16:15:00Z',
					departure: '2024-01-16T16:15:00Z',
					name: 'Osternienburg, Neubau',
				},
				{
					arrival: '2024-01-16T16:16:00Z',
					departure: '2024-01-16T16:16:00Z',
					name: 'Osternienburg, Denkmal',
				},
				{
					arrival: '2024-01-16T16:18:00Z',
					departure: '2024-01-16T16:18:00Z',
					name: 'Osternienburg, Rudolf-Breitscheid-Str.',
				},
				{
					arrival: '2024-01-16T16:19:00Z',
					departure: '2024-01-16T16:19:00Z',
					name: 'Pißdorf (Osternienburg), Ortseingang',
				},
				{
					arrival: '2024-01-16T16:22:00Z',
					departure: '2024-01-16T16:22:00Z',
					name: 'Porst (Köthen), Dessauer Str.',
				},
			],
			pricings: [
				{
					paymentHandlerCompanyName: 'Vetter',
					paymentHandlerCompanyType: 'DISTRIBUTOR',
					paymentInformationAvailable: false,
					amount: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 0,
					deploymentPrice: 0,
				},
			],
			costOfCancellation: 123,
		},
		{
			legId: '57a6f5f3-72b0-42e4-8fee-262323405f47',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T16:33:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T17:30:00Z',
			endDateTimeFix: true,
			duration: 3420,
			distance: 30919.36,
			mode: TripTypeEnum.LBT,
			modeOrigin: 'BUS',
			route: '400',
			headsign: 'Bitterfeld, Bahnhof (Bus)',
			routeId: '1:VETTAB400',
			agencyId: '1:00906',
			agencyName: 'Vetter Verkehrsbetriebe',
			tripShortName: '4000028',
			tripId: '1:77498',
			from: {
				name: 'Köthen, Bahnhof (Bus)',
				stopId: '1:000004966',
				lng: '11.98812',
				lat: '51.752385',
				arrival: '2024-01-16T16:26:00Z',
				departure: '2024-01-16T16:33:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Bitterfeld, Chemiepark',
				stopId: '1:000004727',
				lng: '12.307399',
				lat: '51.625391',
				arrival: '2024-01-16T17:30:00Z',
				departure: '2024-01-16T17:37:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points:
					'k{zzHwldhAgLk[??l@cw@??rFog@??`CgxD??`h@_uP??_I|C??fwCo_D??|WwcE??dI}|E??h`EazG??nOpO??bQoP??Xkd@??lYoR??vd@gF??lStI??fXqG??jKeV??|C~T??rOuK??tNmG??dj@oo@??vb@si@??hh@gY??zY_K??ra@_P??jDg]',
				length: 54,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [
				{
					arrival: '2024-01-16T16:35:00Z',
					departure: '2024-01-16T16:35:00Z',
					name: 'Köthen, Osterköthen',
				},
				{
					arrival: '2024-01-16T16:36:00Z',
					departure: '2024-01-16T16:36:00Z',
					name: 'Köthen, Kaufland',
				},
				{
					arrival: '2024-01-16T16:37:00Z',
					departure: '2024-01-16T16:37:00Z',
					name: 'Köthen, Merziener Str.',
				},
				{
					arrival: '2024-01-16T16:40:00Z',
					departure: '2024-01-16T16:40:00Z',
					name: 'Merzien (Köthen), Str. der DSF',
				},
				{
					arrival: '2024-01-16T16:47:00Z',
					departure: '2024-01-16T16:47:00Z',
					name: 'Quellendorf, Ambulatorium',
				},
				{
					arrival: '2024-01-16T16:49:00Z',
					departure: '2024-01-16T16:49:00Z',
					name: 'Quellendorf, Schule',
				},
				{
					arrival: '2024-01-16T16:54:00Z',
					departure: '2024-01-16T16:54:00Z',
					name: 'Hinsdorf',
				},
				{
					arrival: '2024-01-16T16:57:00Z',
					departure: '2024-01-16T16:57:00Z',
					name: 'Tornau vor der Heide, Thurländer Str.',
				},
				{
					arrival: '2024-01-16T17:00:00Z',
					departure: '2024-01-16T17:00:00Z',
					name: 'Thurland, Hauptstr.',
				},
				{
					arrival: '2024-01-16T17:07:00Z',
					departure: '2024-01-16T17:07:00Z',
					name: 'Wolfen (Bitterfeld)-Nord, Hermann-Fahlke-Str.',
				},
				{
					arrival: '2024-01-16T17:08:00Z',
					departure: '2024-01-16T17:08:00Z',
					name: 'Wolfen (Bitterfeld)-Nord, Dessauer Allee',
				},
				{
					arrival: '2024-01-16T17:09:00Z',
					departure: '2024-01-16T17:09:00Z',
					name: 'Wolfen (Bitterfeld)-Nord, Comeniusstr.',
				},
				{
					arrival: '2024-01-16T17:10:00Z',
					departure: '2024-01-16T17:10:00Z',
					name: 'Wolfen (Bitterfeld)-Nord, Franz-Mehring-Str.',
				},
				{
					arrival: '2024-01-16T17:12:00Z',
					departure: '2024-01-16T17:12:00Z',
					name: 'Steinfurth (Jeßnitz), B184',
				},
				{
					arrival: '2024-01-16T17:13:00Z',
					departure: '2024-01-16T17:13:00Z',
					name: 'Steinfurth (Jeßnitz), Hitschkendorfer Str.',
				},
				{
					arrival: '2024-01-16T17:14:00Z',
					departure: '2024-01-16T17:14:00Z',
					name: 'Wolfen (Bitterfeld), Markt',
				},
				{
					arrival: '2024-01-16T17:15:00Z',
					departure: '2024-01-16T17:15:00Z',
					name: 'Wolfen (Bitterfeld), Bernhard-Göring-Str.',
				},
				{
					arrival: '2024-01-16T17:17:00Z',
					departure: '2024-01-16T17:18:00Z',
					name: 'Wolfen (Bitterfeld), Bahnhof (Bus)',
				},
				{
					arrival: '2024-01-16T17:19:00Z',
					departure: '2024-01-16T17:19:00Z',
					name: 'Wolfen (Bitterfeld), Bahnhofstr.',
				},
				{
					arrival: '2024-01-16T17:21:00Z',
					departure: '2024-01-16T17:21:00Z',
					name: 'Wolfen (Bitterfeld), Filmweg',
				},
				{
					arrival: '2024-01-16T17:22:00Z',
					departure: '2024-01-16T17:22:00Z',
					name: 'Wolfen (Bitterfeld), Greppiner Str.',
				},
				{
					arrival: '2024-01-16T17:23:00Z',
					departure: '2024-01-16T17:23:00Z',
					name: 'Greppin, Farbenstr.',
				},
				{
					arrival: '2024-01-16T17:25:00Z',
					departure: '2024-01-16T17:25:00Z',
					name: 'Bitterfeld, Parsevalstr.',
				},
				{
					arrival: '2024-01-16T17:26:00Z',
					departure: '2024-01-16T17:26:00Z',
					name: 'Bitterfeld, Str. der Wissenschaften',
				},
				{
					arrival: '2024-01-16T17:27:00Z',
					departure: '2024-01-16T17:27:00Z',
					name: 'Bitterfeld, Antonienstr.',
				},
				{
					arrival: '2024-01-16T17:28:00Z',
					departure: '2024-01-16T17:28:00Z',
					name: 'Bitterfeld, Berufsschule',
				},
			],
			pricings: [
				{
					paymentHandlerCompanyName: 'Vetter',
					paymentHandlerCompanyType: 'DISTRIBUTOR',
					paymentInformationAvailable: false,
					amount: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 0,
					deploymentPrice: 0,
				},
			],
			costOfCancellation: 123,
		},
		{
			legId: '7766df12-39d0-42d2-87e8-caaf1eabcb00',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T17:37:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T17:59:00Z',
			endDateTimeFix: true,
			duration: 1320,
			distance: 14191.46,
			mode: TripTypeEnum.LBT,
			modeOrigin: 'BUS',
			route: '440',
			headsign: 'Zörbig, Markt',
			routeId: '1:VETTAB440',
			agencyId: '1:00906',
			agencyName: 'Vetter Verkehrsbetriebe',
			tripShortName: '4400030',
			tripId: '1:78402',
			from: {
				name: 'Bitterfeld, Chemiepark',
				stopId: '1:000004727',
				lng: '12.307399',
				lat: '51.625391',
				arrival: '2024-01-16T17:30:00Z',
				departure: '2024-01-16T17:37:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Zörbig, Markt',
				stopId: '1:000004512',
				lng: '12.118125',
				lat: '51.628041',
				arrival: '2024-01-16T17:59:00Z',
				departure: '2024-01-16T17:59:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points:
					'uabzHexbjAfF`i@??oE~{D??gHxg@??pK``K??lHxpC??fN`P??w_@~uG??qHxb@??wK~S??aC~a@??hLxS??No[',
				length: 24,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [
				{
					arrival: '2024-01-16T17:39:00Z',
					departure: '2024-01-16T17:39:00Z',
					name: 'Bitterfeld, Griesheimstr.',
				},
				{
					arrival: '2024-01-16T17:42:00Z',
					departure: '2024-01-16T17:42:00Z',
					name: 'Sandersdorf, Sportzentrum',
				},
				{
					arrival: '2024-01-16T17:44:00Z',
					departure: '2024-01-16T17:44:00Z',
					name: 'Sandersdorf, Rathaus',
				},
				{
					arrival: '2024-01-16T17:47:00Z',
					departure: '2024-01-16T17:47:00Z',
					name: 'Heideloh, Stakendorfer Str.',
				},
				{
					arrival: '2024-01-16T17:49:00Z',
					departure: '2024-01-16T17:49:00Z',
					name: 'Großzöberitz, Gewerbegebiet',
				},
				{
					arrival: '2024-01-16T17:51:00Z',
					departure: '2024-01-16T17:51:00Z',
					name: 'Großzöberitz, Ernst-Thälmann-Str.',
				},
				{
					arrival: '2024-01-16T17:54:00Z',
					departure: '2024-01-16T17:54:00Z',
					name: 'Zörbig, Flutgraben',
				},
				{
					arrival: '2024-01-16T17:55:00Z',
					departure: '2024-01-16T17:55:00Z',
					name: 'Zörbig, Bitterfelder Str.',
				},
				{
					arrival: '2024-01-16T17:56:00Z',
					departure: '2024-01-16T17:56:00Z',
					name: 'Zörbig, Schützenplatz',
				},
				{
					arrival: '2024-01-16T17:56:00Z',
					departure: '2024-01-16T17:56:00Z',
					name: 'Zörbig, Lindenstr.',
				},
				{
					arrival: '2024-01-16T17:58:00Z',
					departure: '2024-01-16T17:58:00Z',
					name: 'Zörbig, Turm',
				},
			],
			pricings: [
				{
					paymentHandlerCompanyName: 'Vetter',
					paymentHandlerCompanyType: 'DISTRIBUTOR',
					paymentInformationAvailable: false,
					amount: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 0,
					deploymentPrice: 0,
				},
			],
			costOfCancellation: 123,
		},
		{
			legId: '31849a08-ad0c-45f1-949b-64f8349f15aa',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T17:59:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T18:02:19Z',
			endDateTimeFix: true,
			duration: 199,
			distance: 234.78,
			mode: TripTypeEnum.WALK,
			modeOrigin: TripTypeEnum.WALK,
			from: {
				name: 'Zörbig, Markt',
				stopId: '1:000004512',
				lng: '12.118125',
				lat: '51.628041',
				arrival: '2024-01-16T17:59:00Z',
				departure: '2024-01-16T17:59:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Zörbig, Sachsen-Anhalt, Deutschland',
				lng: '12.12023',
				lat: '51.62729',
				arrival: '2024-01-16T18:02:19Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points: 'grbzHgy}hAK?AmAAkA?_@Aq@Aq@x@Gr@GAM@?TCR?RC?_A?_@',
				length: 16,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [],
			costOfCancellation: 123,
		},
	],
};

export const itineraryMixed: ItineraryView = {
	startDateTime: '2024-01-16T15:58:32Z',
	endDateTime: '2024-01-16T17:19:30Z',
	duration: 4858,
	walkTime: 1438,
	walkDistance: 12338.35,
	airDistance: 0,
	paymentOptions: [PaymentFormEnum.DIGITAL],
	dticketEligible: false,
	legs: [
		{
			legId: '42f3ac21-43b4-4801-9f27-5642ed25e8d8',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T15:58:32Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T16:00:00Z',
			endDateTimeFix: true,
			duration: 88,
			distance: 108.72,
			mode: TripTypeEnum.WALK,
			modeOrigin: TripTypeEnum.WALK,
			from: {
				name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
				lng: '12.044637',
				lat: '51.855333',
				departure: '2024-01-16T15:58:32Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Aken, Markt',
				stopId: '1:000016812',
				lng: '12.044659',
				lat: '51.85455',
				arrival: '2024-01-16T16:00:00Z',
				departure: '2024-01-16T16:00:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points: 'y~n{H}mohAB}@tBd@b@JAF',
				length: 5,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [],
			costOfCancellation: 123,
		},
		{
			legId: 'cbcd8da7-cb85-47d1-b59d-231de8e0aab4',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T16:00:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T16:26:00Z',
			endDateTimeFix: true,
			duration: 1560,
			distance: 14681.88,
			mode: TripTypeEnum.LBT,
			modeOrigin: 'BUS',
			route: '470',
			headsign: 'Gröbzig, Mühlbreite',
			routeId: '1:VETTAB470',
			agencyId: '1:00906',
			agencyName: 'Vetter Verkehrsbetriebe',
			tripShortName: '4700026',
			tripId: '1:79003',
			from: {
				name: 'Aken, Markt',
				stopId: '1:000016812',
				lng: '12.044659',
				lat: '51.85455',
				arrival: '2024-01-16T16:00:00Z',
				departure: '2024-01-16T16:00:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Köthen, Bahnhof (Bus)',
				stopId: '1:000004966',
				lng: '11.98812',
				lat: '51.752385',
				arrival: '2024-01-16T16:26:00Z',
				departure: '2024-01-16T16:33:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points:
					'}yn{HanohAwE|Y??ff@`S??jh@vx@??~_A|h@??pc@|F??p`@hL??zg@joA??rs@yx@??dj@uE??`Tug@??`Gkp@??tTbh@??rB|iA??~bCdlA??liBhaA',
				length: 30,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [
				{
					arrival: '2024-01-16T16:02:00Z',
					departure: '2024-01-16T16:02:00Z',
					name: 'Aken, Sekundarschule',
				},
				{
					arrival: '2024-01-16T16:03:00Z',
					departure: '2024-01-16T16:03:00Z',
					name: 'Aken, Heidestr.',
				},
				{
					arrival: '2024-01-16T16:05:00Z',
					departure: '2024-01-16T16:05:00Z',
					name: 'Aken, Mennewitzer Weg',
				},
				{
					arrival: '2024-01-16T16:06:00Z',
					departure: '2024-01-16T16:06:00Z',
					name: 'Aken, Heidehof',
				},
				{
					arrival: '2024-01-16T16:07:00Z',
					departure: '2024-01-16T16:07:00Z',
					name: 'Trebbichau (Micheln), Wasserwerk',
				},
				{
					arrival: '2024-01-16T16:07:00Z',
					departure: '2024-01-16T16:07:00Z',
					name: 'Trebbichau (Micheln), Heidekrug',
				},
				{
					arrival: '2024-01-16T16:09:00Z',
					departure: '2024-01-16T16:09:00Z',
					name: 'Trebbichau (Micheln), Ort',
				},
				{
					arrival: '2024-01-16T16:12:00Z',
					departure: '2024-01-16T16:12:00Z',
					name: 'Osternienburg, Ernst-Thälmann-Str.',
				},
				{
					arrival: '2024-01-16T16:13:00Z',
					departure: '2024-01-16T16:13:00Z',
					name: 'Osternienburg, Apotheke',
				},
				{
					arrival: '2024-01-16T16:15:00Z',
					departure: '2024-01-16T16:15:00Z',
					name: 'Osternienburg, Neubau',
				},
				{
					arrival: '2024-01-16T16:16:00Z',
					departure: '2024-01-16T16:16:00Z',
					name: 'Osternienburg, Denkmal',
				},
				{
					arrival: '2024-01-16T16:18:00Z',
					departure: '2024-01-16T16:18:00Z',
					name: 'Osternienburg, Rudolf-Breitscheid-Str.',
				},
				{
					arrival: '2024-01-16T16:19:00Z',
					departure: '2024-01-16T16:19:00Z',
					name: 'Pißdorf (Osternienburg), Ortseingang',
				},
				{
					arrival: '2024-01-16T16:22:00Z',
					departure: '2024-01-16T16:22:00Z',
					name: 'Porst (Köthen), Dessauer Str.',
				},
			],
			pricings: [
				{
					paymentHandlerCompanyName: 'Vetter',
					paymentHandlerCompanyType: 'DISTRIBUTOR',
					paymentInformationAvailable: false,
					amount: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 0,
					deploymentPrice: 0,
				},
			],
			costOfCancellation: 123,
		},
		{
			legId: 'caa90e79-9844-449f-b28c-bcc741176810',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T16:33:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T16:57:00Z',
			endDateTimeFix: true,
			duration: 1440,
			distance: 15428.88,
			mode: TripTypeEnum.LBT,
			modeOrigin: 'BUS',
			route: '400',
			headsign: 'Bitterfeld, Bahnhof (Bus)',
			routeId: '1:VETTAB400',
			agencyId: '1:00906',
			agencyName: 'Vetter Verkehrsbetriebe',
			tripShortName: '4000028',
			tripId: '1:77498',
			from: {
				name: 'Köthen, Bahnhof (Bus)',
				stopId: '1:000004966',
				lng: '11.98812',
				lat: '51.752385',
				arrival: '2024-01-16T16:26:00Z',
				departure: '2024-01-16T16:33:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Tornau vor der Heide, Thurländer Str.',
				stopId: '1:000015640',
				lng: '12.184695',
				lat: '51.719085',
				arrival: '2024-01-16T16:57:00Z',
				departure: '2024-01-16T16:57:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points:
					'k{zzHwldhAgLk[??l@cw@??rFog@??`CgxD??`h@_uP??_I|C??fwCo_D??|WwcE',
				length: 16,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [
				{
					arrival: '2024-01-16T16:35:00Z',
					departure: '2024-01-16T16:35:00Z',
					name: 'Köthen, Osterköthen',
				},
				{
					arrival: '2024-01-16T16:36:00Z',
					departure: '2024-01-16T16:36:00Z',
					name: 'Köthen, Kaufland',
				},
				{
					arrival: '2024-01-16T16:37:00Z',
					departure: '2024-01-16T16:37:00Z',
					name: 'Köthen, Merziener Str.',
				},
				{
					arrival: '2024-01-16T16:40:00Z',
					departure: '2024-01-16T16:40:00Z',
					name: 'Merzien (Köthen), Str. der DSF',
				},
				{
					arrival: '2024-01-16T16:47:00Z',
					departure: '2024-01-16T16:47:00Z',
					name: 'Quellendorf, Ambulatorium',
				},
				{
					arrival: '2024-01-16T16:49:00Z',
					departure: '2024-01-16T16:49:00Z',
					name: 'Quellendorf, Schule',
				},
				{
					arrival: '2024-01-16T16:54:00Z',
					departure: '2024-01-16T16:54:00Z',
					name: 'Hinsdorf',
				},
			],
			pricings: [
				{
					paymentHandlerCompanyName: 'Vetter',
					paymentHandlerCompanyType: 'DISTRIBUTOR',
					paymentInformationAvailable: false,
					amount: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 0,
					deploymentPrice: 0,
				},
			],
			costOfCancellation: 123,
		},
		{
			legId: '3b4b8eef-dd72-48b7-8aa3-9435a3d9f210',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T16:57:00Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T16:58:00Z',
			endDateTimeFix: true,
			duration: 60,
			distance: 0,
			mode: TripTypeEnum.WALK,
			modeOrigin: TripTypeEnum.WALK,
			from: {
				name: 'Tornau vor der Heide, Thurländer Str.',
				stopId: '1:000015640',
				lng: '12.184695',
				lat: '51.719085',
				arrival: '2024-01-16T16:57:00Z',
				departure: '2024-01-16T16:57:00Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Am Trappenberg',
				lng: '12.1846983',
				lat: '51.7191123',
				arrival: '2024-01-16T16:58:00Z',
				departure: '2024-01-16T16:58:00Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points: 'gktzHiyjiAE?',
				length: 2,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [],
			costOfCancellation: 123,
		},
		{
			legId: 'b7da71ff-b0cd-4d9d-9f51-b301868aa5d5',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T17:03:30.363Z',
			startDateTimeWindowStart: '2024-01-16T17:03:30.363588914Z',
			startDateTimeWindowEnd: '2024-01-16T17:18:30.363588914Z',
			startDateTimeFix: false,
			endDateTime: '2024-01-16T17:54:14.363Z',
			endDateTimeWindowStart: '2024-01-16T17:03:30.363588914Z',
			endDateTimeWindowEnd: '2024-01-16T17:54:14.363588914Z',
			endDateTimeFix: false,
			cancellationFreeUntil: '2024-01-16T16:03:30.363Z',
			costOfCancellation: 310,
			duration: 1072,
			distance: 11962.14,
			mode: TripTypeEnum.LBODTFLEX,
			modeOrigin: 'CAR',
			agencyName: 'Vetter Verkehrsbetriebe',
			from: {
				name: 'Am Trappenberg 2, 06779 Raguhn-Jeßnitz, Deutschland',
				lng: '12.1846983',
				lat: '51.7191123',
				arrival: '2024-01-16T16:58:00Z',
				departure: '2024-01-16T16:58:00Z',
				locationType: DisplayType.ADDRESS,
			},
			to: {
				name: 'Zörbig, Sachsen-Anhalt, Deutschland',
				lng: '12.122784',
				lat: '51.6284022',
				arrival: '2024-01-16T17:15:52Z',
				departure: '2024-01-16T17:15:52Z',
				locationType: DisplayType.ADDRESS,
			},
			legGeometry: {
				points:
					'mktzHiyjiA?VCr@Ab@A\\VJTHRDZDTBh@?fEOlAGpAMbBUzAS|@Kp@GVEpAM~DOnAGvAEl@@b@FlB`@~@Rb@Dp@Ev@OnImBj@Kj@Sh@_@ZSVK^CP?N?VBR?ZC`@IvBc@fH{A~FoAzGyAbR{DbEy@p@O|GuAd@IvCo@`Ci@fCi@|@UnBk@jBo@lBm@lBg@zAWn@I^CVAz@BfAXhAj@`@Vh@j@l@t@h@`Ad@hANj@Rt@n@fCJb@TbATv@Pl@HT\\|@j@tAh@fAb@t@tApBfChCnBnAfGlDj@Zf@Zd@b@nE`E`EtDjF|ElCbCrArA\\TLJ~@t@tAhAhA|@f@`@DBNNv@p@TTlNnMdQhMjChBxChAtGpArFlAfBr@pB~@jDhBtEhCfEtC`ChBp@h@n@d@pAhARPXV|AvA|@v@fAt@n@`@`A`@f@N\\J\\Fj@H|@FrA@fCEfA?vADlBRbBXbBd@b@P`@LfBz@TLTNZThAv@nAfAn@n@r@v@pA`Bt@fAv@lApAhCf@hAf@lAjAjDb@zAVfAXlA\\|AJn@ZfBVlBHt@Jt@NjBP`CFp@JfBLbBLbBN`BNpANnARpAPfATlAn@xCVdAnA`EZx@`@hAP`@Tf@p@tA`AdBXb@^l@^h@dAtAtBzBfCjCtE~EtLpNz_@`e@zBnCV\\NXLJLJNVl@p@jOfRfGtHpDlFp@`APRDDp@v@TRTT|BrBh@d@l@bAd@pAH^^|ACFAF?F?H@FBDBBB@D@BA',
				length: 228,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 160,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
					pricePerPassenger: 160,
					deploymentPrice: 0,
				},
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 210,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
					pricePerPassenger: 210,
					deploymentPrice: 0,
				},
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 530,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
					pricePerPassenger: 530,
					deploymentPrice: 0,
				},
				{
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					amount: 740,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
					pricePerPassenger: 740,
					deploymentPrice: 0,
				},
			],
		},
		{
			legId: '4e72c014-1ccc-4e2c-9167-df3cd7d2fb40',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-16T17:54:14.363Z',
			startDateTimeFix: true,
			endDateTime: '2024-01-16T17:57:52.363Z',
			endDateTimeFix: true,
			duration: 218,
			distance: 267.49,
			mode: TripTypeEnum.WALK,
			modeOrigin: TripTypeEnum.WALK,
			from: {
				name: 'corner of L 143 and Lange Straße',
				lng: '12.122784',
				lat: '51.6284022',
				arrival: '2024-01-16T17:15:52Z',
				departure: '2024-01-16T17:15:52Z',
				locationType: DisplayType.STOP,
			},
			to: {
				name: 'Zörbig, Sachsen-Anhalt, Deutschland',
				lng: '12.12023',
				lat: '51.627282',
				arrival: '2024-01-16T17:19:30Z',
				locationType: DisplayType.STOP,
			},
			legGeometry: {
				points: 'otbzHkv~hAAFC`@?L?TB~@BbALANBHHJRPj@Lb@Nl@Pl@N`@\\Cz@K?ZAr@',
				length: 20,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [],
			costOfCancellation: 123,
		},
	],
};

export const pureLBODTFlex200 = {
	requestedParams: {
		fromPlace: {
			name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
			lat: '51.855333',
			lng: '12.044637',
			locationType: DisplayType.ADDRESS,
			zipcode: '06385',
			province: 'ST',
		},
		toPlace: {
			name: 'Wolfen, Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
			lat: '51.66343',
			lng: '12.275519',
			locationType: DisplayType.ADDRESS,
			zipcode: '06766',
			province: 'ST',
		},
		datetime: '2024-01-24T13:03:26.632Z',
		arriveBy: false,
		specialNeeds: 'NONE',
	},
	itineraries: [itineraryLBODTFlex],
};

export const cheaperRides200 = {
	requestedParams: {
		fromPlace: {
			name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
			lat: '51.855333',
			lng: '12.044637',
			locationType: DisplayType.ADDRESS,
			zipcode: '06385',
			province: 'ST',
		},
		toPlace: {
			name: 'Zörbig, Sachsen-Anhalt, Deutschland',
			lat: '51.627282',
			lng: '12.12023',
			locationType: DisplayType.ADDRESS,
			zipcode: '06780',
			province: 'ST',
		},
		datetime: '2024-01-16T15:53:28.623Z',
		arriveBy: false,
		specialNeeds: 'NONE',
	},
	itineraries: [itineraryLBT, itineraryLBODTFlex, itineraryMixed],
};

export const itineraryKK: ItineraryView = {
	startDateTime: '2024-01-24T14:13:27.106Z',
	endDateTime: '2024-01-24T15:38:31.106Z',
	duration: 2102,
	walkTime: 0,
	walkDistance: 0,
	airDistance: 26605,
	paymentOptions: [PaymentFormEnum.DIGITAL],
	dticketEligible: false,
	legs: [
		{
			legId: 'legId1',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-24T14:13:27.106Z',
			startDateTimeFix: false,
			endDateTime: '2024-01-24T15:38:31.106Z',
			endDateTimeFix: false,
			costOfCancellation: 640,
			duration: 2102.1,
			distance: 33464.5,
			mode: TripTypeEnum.LBODTFLEX,
			modeOrigin: 'CAR',
			route: '',
			agencyName: 'Vetter Verkehrsbetriebe',
			from: {
				name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
				lng: '12.044637',
				lat: '51.855333',
				arrival: '2024-01-24T14:13:27.106Z',
				departure: '2024-01-24T14:13:27.106Z',
				locationType: DisplayType.ADDRESS,
			},
			to: {
				name: 'Wolfen, Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
				lng: '12.275519',
				lat: '51.66343',
				arrival: '2024-01-24T15:38:31.106Z',
				departure: '2024-01-24T15:38:31.106Z',
				locationType: DisplayType.ADDRESS,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [
				{
					amount: 640,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 640,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				},
				{
					amount: 740,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 740,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				},
				{
					amount: 1650,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 1650,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					amount: 2020,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 2020,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
			],
			cancellationRules: [
				{
					secondsBeforeRideStart: 7200,
					cost: 10,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 1800,
					cost: 320,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 0,
					cost: 920,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 7200,
					cost: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					secondsBeforeRideStart: 1800,
					cost: 50,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					secondsBeforeRideStart: 0,
					cost: 100,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
			],
			timeInfo: {
				start: {
					startTime: '2025-06-16T12:39:30.643Z',
					startTimeWindow: {
						start: '2025-06-16T12:39:30.643675538Z',
						end: '2025-06-16T12:54:30.643675538Z',
					},
					// startTimeForCancellation: null,
					// overwrittenStartTimeWindow: null,
					// currentlyPredictedStartTime: null,
				},
				end: {
					endTime: '2025-06-16T14:24:34.643Z',
					endTimeWindow: {
						start: '2025-06-16T13:20:25.643675538Z',
						end: '2025-06-16T14:24:34.643675538Z',
					},
					// overwrittenEndTimeWindow: null,
					// currentlyPredictedEndTime: null,
				},
				includedPlannedDelayInMinutes: 0,
				startAndEndTimeFixed: false,
			},
		},
		{
			legId: 'legId2',
			legStatus: PassengerLegStatusEnum.BOOKED,
			startDateTime: '2024-01-24T14:13:27.106Z',
			startDateTimeFix: false,
			endDateTime: '2024-01-24T15:38:31.106Z',
			endDateTimeFix: false,
			costOfCancellation: 640,
			duration: 2102.1,
			distance: 33464.5,
			mode: TripTypeEnum.LBODTFLEX,
			modeOrigin: 'CAR',
			route: '',
			agencyName: 'Vetter Verkehrsbetriebe',
			from: {
				name: 'Aken (Elbe), Sachsen-Anhalt, Deutschland',
				lng: '12.044637',
				lat: '51.855333',
				arrival: '2024-01-24T14:13:27.106Z',
				departure: '2024-01-24T14:13:27.106Z',
				locationType: DisplayType.ADDRESS,
			},
			to: {
				name: 'Wolfen, Bitterfeld-Wolfen, Sachsen-Anhalt, Deutschland',
				lng: '12.275519',
				lat: '51.66343',
				arrival: '2024-01-24T15:38:31.106Z',
				departure: '2024-01-24T15:38:31.106Z',
				locationType: DisplayType.ADDRESS,
			},
			paymentOptions: [PaymentFormEnum.DIGITAL],
			intermediateStops: [],
			pricings: [
				{
					amount: 640,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 640,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.DISCOUNTED_TICKET_PRESENT,
				},
				{
					amount: 740,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 740,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NON_DISCOUNTED_TICKET_PRESENT,
				},
				{
					amount: 1650,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 1650,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					amount: 2020,
					paymentHandlerCompanyName: 'MoPla Solutions GmbH',
					paymentHandlerCompanyType: 'MOPLA',
					paymentInformationAvailable: true,
					pricePerPassenger: 2020,
					deploymentPrice: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
			],
			cancellationRules: [
				{
					secondsBeforeRideStart: 7200,
					cost: 10,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 1800,
					cost: 320,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 0,
					cost: 920,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.NO_DISCOUNT,
				},
				{
					secondsBeforeRideStart: 7200,
					cost: 0,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					secondsBeforeRideStart: 1800,
					cost: 50,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
				{
					secondsBeforeRideStart: 0,
					cost: 100,
					currency: CurrencyCodeEnum.EUR,
					discount: DiscountStateEnum.PERSONAL_DISCOUNT_AVAILABLE,
				},
			],
			timeInfo: {
				start: {
					startTime: '2025-06-16T12:39:30.643Z',
					startTimeWindow: {
						start: '2025-06-16T12:39:30.643675538Z',
						end: '2025-06-16T12:54:30.643675538Z',
					},
					// startTimeForCancellation: null,
					// overwrittenStartTimeWindow: null,
					// currentlyPredictedStartTime: null,
				},
				end: {
					endTime: '2025-06-16T14:24:34.643Z',
					endTimeWindow: {
						start: '2025-06-16T13:20:25.643675538Z',
						end: '2025-06-16T14:24:34.643675538Z',
					},
					// overwrittenEndTimeWindow: null,
					// currentlyPredictedEndTime: null,
				},
				includedPlannedDelayInMinutes: 0,
				startAndEndTimeFixed: false,
			},
		},
	],
	signature: 'signature',
};
